module.exports = __webpack_public_path__ + "static/media/trophy.c292ef8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/milestone/trophy.png
// module id = 2093
// module chunks = 0